var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotteryHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.8,
    height: 18.75,
    viewBox: "0 0 20.8 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M36.241,22.009a2.287,2.287,0,0,0-1.687-.759H29.5v-1.5A3.759,3.759,0,0,0,25.75,16a.769.769,0,0,0-.675.413L21.531,23.5H17.5A1.5,1.5,0,0,0,16,25v8.25a1.5,1.5,0,0,0,1.5,1.5H33.428a2.259,2.259,0,0,0,2.231-1.969l1.125-9a2.3,2.3,0,0,0-.544-1.772ZM17.5,25h3.75v8.25H17.5Z",
    transform: "translate(-16 -16)",
    fill: "#e86262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotteryHome);
export default __webpack_public_path__ + "static/media/LOTTERY_HOME.a2069495f78bbb501d6f0c950efde45e.svg";
export { ForwardRef as ReactComponent };